import { useTextColor } from '@webstollen/react-native/lib/hooks/useColors'
import { StyleSheet, Platform } from 'react-native'
import colors from '../../../../constants/colors'

const useStyles = () => {
  return StyleSheet.create({
    content: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,

      justifyContent: 'space-between',
    },

    keyFigures: {
      flexDirection: 'row',
    },

    item: {
      // display: 'flex',
      flex: 1,
      flexDirection: 'row',
      // width: '50%',
      padding: 5,
    },

    titleWrapper: {
      flexDirection: 'column',
    },
    itemTitle: {
      fontSize: 12,
      color: useTextColor(),
      marginBottom: Platform.select({ default: undefined, web: 4 }),
    },
    itemCurrentValue: {
      fontSize: 15,
    },

    percentage: {
      flex: 1,
      textAlign: 'right',
      alignSelf: 'flex-end',
      fontSize: 12,
    },

    negative: {
      color: colors.error,
    },
    positive: {
      color: colors.success,
    },

    status: {
      // flex: 1,
      flexDirection: 'row',
      flexWrap: 'wrap',
      // alignSelf: 'flex-end',
    },

    statusItem: {
      // display: 'flex',
      flexDirection: 'row',
      width: '50%',
      padding: 5,
    },

    itemText: {
      fontSize: 10,
      paddingLeft: 10,
      lineHeight: Platform.select({ default: 15, ios: 18 }),
      // textAlignVertical: 'bottom',
    },
  })
}

export default useStyles
